var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "32px",
    viewBox: "0 0 31 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Booking-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Booking-Page---2.1.1",
    transform: "translate(-450.000000, -1281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(319.000000, 585.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(111.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,16.2656023 C31,15.1335269 30.9005682,14.0449927 30.7159091,13 L16,13 L16,19.1756168 L24.4090909,19.1756168 C24.046875,21.1712627 22.9460227,22.862119 21.2911932,23.9941945 L21.2911932,28 L26.3409091,28 C29.2954545,25.2206096 31,21.1277213 31,16.2656023 L31,16.2656023 Z",
    id: "Shape",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3629456,32 C20.7025132,32 24.3407364,30.5628507 27,28.1116723 L21.8056692,24.0847363 C20.3664524,25.0476992 18.5254237,25.6167228 16.3629456,25.6167228 C12.1767972,25.6167228 8.63354763,22.7934905 7.36966686,19 L2,19 L2,23.1582492 C4.64465225,28.4034792 10.0800701,32 16.3629456,32 L16.3629456,32 Z",
    id: "Shape",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,18.9615385 C6.68214654,18.0263158 6.50154799,17.0273279 6.50154799,16 C6.50154799,14.9726721 6.68214654,13.9736842 7,13.0384615 L7,9 L1.69040248,9 C0.614035088,11.104251 0,13.4848178 0,16 C0,18.5151822 0.614035088,20.895749 1.69040248,23 L7,18.9615385 L7,18.9615385 Z",
    id: "Shape",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2961024,6.38327722 C18.6448517,6.38327722 20.7536358,7.19304153 22.4115765,8.78338945 L27,4.18013468 C24.2294939,1.59034792 20.6082024,0 16.2961024,0 C10.0424666,0 4.63234439,3.59652076 2,8.84175084 L7.34467714,13 C8.60267597,9.20650954 12.1294357,6.38327722 16.2961024,6.38327722 L16.2961024,6.38327722 Z",
    id: "Shape",
    fill: "#EA4335"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.77c75409e3cea2a3d6574c9d517e1207.svg";
export { ForwardRef as ReactComponent };